import React from 'react';
import { Container, Card, CardContent, Typography, Box, Grid, Link } from '@mui/material';

function Contact() {
    return (
        <Container maxWidth="lg">
            {/* Header Section */}
            <Box sx={{ textAlign: 'center', marginBottom: 4, marginTop: 15 }}>
                <Card sx={{ textAlign: 'center', padding: 4 }}>
                    <Typography variant="h4" color="text.primary" gutterBottom>
                        Contact Us
                    </Typography>
                    <Typography variant="h6" color="text.secondary">
                        Have questions or need assistance? Feel free to reach out to us.
                    </Typography>
                </Card>
            </Box>

            {/* Contact Information */}
            <Grid container spacing={4}>
                <Grid item xs={12} sm={6}>
                    <Card>
                        <CardContent>
                            <Typography variant="h5" color="text.primary" gutterBottom>
                                Email Us
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                <Link href="mailto:jc.glgolf@gmail.com" underline="hover">
                                    jc.glgolf@gmail.com
                                </Link>
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                <Link href="mailto:chase.glgolf@gmail.com" underline="hover">
                                    chase.glgolf@gmail.com
                                </Link>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Card>
                        <CardContent>
                            <Typography variant="h5" color="text.primary" gutterBottom>
                                Call Us
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Phone: (519) 859-6547
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Phone: (519) 495-8310
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {/* <Box sx={{ textAlign: 'center', marginTop: 4 }}>
                <Card sx={{ textAlign: 'center', padding: 4 }}>
                    <Typography variant="h5" color="text.primary" gutterBottom>
                        Visit Us
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Address?
                    </Typography>
                </Card>
            </Box> */}
        </Container>
    );
}

export default Contact;
